import {
  Components,
  InputInformation,
  ValidationType,
  Size,
  RegexLib,
} from '@utahdts/dts-react-common';
import Inputmask from 'inputmask';
import { formatTextFieldValue } from '../../misc/textFieldFormatter';
import wireInputChanges from './wireInputChanges';

// eslint-disable-next-line no-unused-vars
export default ({ inputsOnChange, drugTypeChange }, isNew, inputValues) => {
  const inputs = {
    ndc: new InputInformation({
      field: 'ndc',
      label: 'National Drug Code:',
      type: Components.TEXT_INPUT,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
      maskType: {
        inputMask: new Inputmask('99999999999', {
          placeholder: '',
          clearMaskOnLostFocus: false,
          autoUnmask: true,
          onBeforePaste: (value) => {
            const formatted = formatTextFieldValue(value);
            const digits = formatted.supported
              ? formatted.value.match(/\d+/g)
              : null;
            digits && inputsOnChange('ndc', digits.join(''));
          },
        }),
      },
    }),
    drugDescription: new InputInformation({
      field: 'drugDescription',
      label: 'Drug description',
      type: Components.TEXT_AREA,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
    }),
    drugType: new InputInformation({
      field: 'drugType',
      label: 'Drug Type:',
      type: Components.SELECT_INPUT,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
      options: [
        { label: 'Brand', value: 'Brand' },
        { label: 'Generic', value: 'Generic' },
      ],
      multiSelect: false,
    }),
    effectiveDate: new InputInformation({
      field: 'effectiveDate',
      label: 'Effective Date:',
      type: Components.CALENDAR_INPUT,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
      maskType: {
        inputMask: new Inputmask('datetime', {
          inputFormat: 'mm/dd/yyyy',
          placeholder: 'MM/DD/YYYY',
          clearMaskOnLostFocus: false,
          onBeforePaste: (value) => {
            const formatted = formatTextFieldValue(value);
            formatted.supported &&
              formatted.value.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/) &&
              inputsOnChange('effectiveDate', formatted.value);
          },
        }),
        validation: {
          validationRegExp: RegexLib.DATE,
          validationErrorMessage: (data) => `${data} does not match MM/DD/YYYY`,
        },
        className: 'mask-date',
      },
    }),
    increaseAmount: new InputInformation({
      field: 'increaseAmount',
      label: 'Increase Amount (numbers only):',
      type: Components.TEXT_INPUT,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
    }),
    wacAfterIncrease: new InputInformation({
      field: 'wacAfterIncrease',
      label: 'WAC After Increase (numbers only):',
      type: Components.TEXT_INPUT,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
    }),
    historyOneYear: new InputInformation({
      field: 'historyOneYear',
      label: 'History One Year (numbers only):',
      type: Components.TEXT_INPUT,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
    }),
    historyTwoYear: new InputInformation({
      field: 'historyTwoYear',
      label: 'History Two Year (numbers only):',
      type: Components.TEXT_INPUT,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
    }),
    increaseFactors: new InputInformation({
      field: 'increaseFactors',
      label: 'Increase Factors:',
      type: Components.TEXT_AREA,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
    }),
    rdCosts: new InputInformation({
      field: 'rdCosts',
      label: 'R&D Costs (numbers only):',
      type: Components.TEXT_INPUT,
      validationTypes: ValidationType.REQUIRED,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
    }),
    comments: new InputInformation({
      field: 'comments',
      label: 'Comments:',
      type: Components.TEXT_AREA,
      size: Size.FULL_WIDTH,
      disabled: !isNew,
    }),
  };

  wireInputChanges(inputs, inputsOnChange);
  inputs.drugType.onChange = drugTypeChange;

  return inputs;
};
